import { combineReducers } from "redux";

import Auth from "./auth/reducers";
import Layout from "./layout/reducers";
import Users from "./users/reducers";
import Locations from "./locations/reducers";
import Packages from "./packages/reducer";
import Devices from "./devices/reducer";
import Rentals from "./rentals/reducers";
import PowerBank from "./powerbanks/reducers";
import Reports from "./reports/reducers";
import Complaints from "./complaints/reducers";
import Withdraws from "./withdraws/reducers";
import Corporates from "./corporate/reducer";
import ReferelCode from "./referel-code/reducers";
import WattiReducer from "./watti/reducers";
import OffersReducer from "./offers/reducer";

export default combineReducers({
  Auth,
  Layout,
  Users,
  Locations,
  Corporates,
  ReferelCode,
  Watti: WattiReducer,
  Offers: OffersReducer,
  Packages,
  Devices,
  Rentals,
  PowerBank,
  Reports,
  Complaints,
  Withdraws,
});
